import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function UrgentCarePharmacy() {
  return <section data-section-id="238114" id="urgent-care-pharmacy" className="dark bg-background text-foreground relative overflow-hidden py-12 sm:py-16 border-y border-primary/20">
      {}
      <div className="absolute inset-0 bg-gradient-to-r from-primary/20 via-background to-primary/20 z-0" />
      <div className="absolute inset-0 bg-primary/10 blur-3xl z-0" />

      <div className="container mx-auto px-4 relative z-10 flex flex-col lg:flex-row items-center justify-center gap-8 lg:gap-16">
        
        {}
        <div className="flex flex-col sm:flex-row items-center gap-6 text-center sm:text-left">
          <div className="bg-destructive/20 p-5 rounded-lg animate-pulse ring-4 ring-destructive/30">
            <Phone className="w-10 h-10 sm:w-12 sm:h-12 text-destructive" />
          </div>
          <div>
            <h2 className="text-2xl sm:text-3xl font-bold text-foreground uppercase tracking-wider font-default mb-2 drop-shadow-md">
              Veterinary Emergency 24/7
            </h2>
            <p className="text-4xl sm:text-5xl lg:text-6xl font-bold text-primary font-default tracking-tight drop-shadow-lg">
              01 23 45 67 89
            </p>
          </div>
        </div>

        {}
        <div className="w-full sm:w-auto">
          <Button asChild size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 text-lg sm:text-xl px-8 py-8 rounded-lg shadow-xl transition-transform hover:scale-105 font-bold">
            <Link to="tel:0123456789">
              <Phone className="mr-3 w-6 h-6" />
              Emergency Call
            </Link>
          </Button>
        </div>

      </div>
    </section>;
}